import {combineReducers} from 'redux'
import {type CurrentCourseActionT} from '@freckle/student/ts/actions/current-course'
import {type CurrentTeacherActionT} from '@freckle/student/ts/actions/current-teacher'
import {type ItemOwnershipsActionT} from '@freckle/student/ts/actions/item-ownerships'
import {type ItemsActionT} from '@freckle/student/ts/actions/items'
import {type LanguagesActionT} from '@freckle/student/ts/actions/languages'
import {type PiggyStoreStatusActionT} from '@freckle/student/ts/actions/piggy-store-status'
import {type SelfStudentActionT} from '@freckle/student/ts/actions/self-student'
import {type SettingsActionT} from '@freckle/student/ts/actions/settings'
import {currentCourseReducer} from './current-course'
import {currentTeacherReducer} from './current-teacher'
import {itemOwnershipsReducer} from './item-ownerships'
import {itemsReducer} from './items'
import {languagesReducer} from './languages'
import {piggyStoreStatusReducer} from './piggy-store-status'
import {selfStudentReducer} from './self-student'
import {settingsReducer} from './settings'

const allReducers = {
  selfStudent: selfStudentReducer,
  currentCourse: currentCourseReducer,
  currentTeacher: currentTeacherReducer,
  settings: settingsReducer,
  piggyStoreStatus: piggyStoreStatusReducer,
  languages: languagesReducer,
  items: itemsReducer,
  itemOwnerships: itemOwnershipsReducer
}

export type AllActionT =
  | SelfStudentActionT
  | CurrentCourseActionT
  | CurrentTeacherActionT
  | SettingsActionT
  | PiggyStoreStatusActionT
  | LanguagesActionT
  | ItemsActionT
  | ItemOwnershipsActionT

export default combineReducers(allReducers)
